function selectHasOption(select, value) {
    return Array.from(select.options).some(option => option.value === value);
}

// Sets the filter controls from the url parameters, ignoring values that
// don't match an option. Returns the applied filters (undefined if unset).
export function applyUrlFilters(artistFilter, characterFilter) {
    const params = new URLSearchParams(window.location.search);
    const artist = params.get("artist");
    const character = params.get("character");
    const applied = { artist: undefined, character: undefined };

    if (artist && selectHasOption(artistFilter, artist)) {
        artistFilter.value = artist;
        applied.artist = artist;
    }
    if (character && selectHasOption(characterFilter, character)) {
        characterFilter.value = character;
        applied.character = character;
    }

    // Drop any parameters that didn't match a filter option
    updateUrlFilters(applied.artist, applied.character);
    return applied;
}

// Reflects the current filters in the url without adding a history entry.
export function updateUrlFilters(artist, character) {
    const url = new URL(window.location.href);

    if (artist) {
        url.searchParams.set("artist", artist);
    } else {
        url.searchParams.delete("artist");
    }
    if (character) {
        url.searchParams.set("character", character);
    } else {
        url.searchParams.delete("character");
    }

    if (url.href !== window.location.href) {
        window.history.replaceState(window.history.state, "", url);
    }
}